<template>
  <NotPermission v-if="!authenticated" />
  <v-container v-else fluid grid-list-lg>
    <template>
      <Breadcrumbs :routes="[{ name: 'Inicio' }, { name: 'Nueva Etiqueta' }]" />
      <v-layout row wrap>
        <v-flex md12 sm12 xs12>
          <v-card>
            <v-card-title primary-title>
              <span class="success--text font-weight-bold headline">Crear etiqueta</span>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-0">
              <v-form
                ref="form"
                v-model="validForm"
                lazy-validation
                @submit.prevent="submitCreateEtiqueta"
              >
                <v-container fluid grid-list-lg>                  
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12>
                      <v-autocomplete
                        v-model="form.tipo"
                        :items="tipos"
                        dense
                        outline
                        clearable
                        small-chips
                        label="Tipo"
                        :rules="rules.tipo"
                        :error="!!formErrors.tipo"
                        :error-messages="formErrors.tipo"
                        @keyup="
                          () => {
                            formErrors.tipo = undefined;
                            delete formErrors.tipo;
                          }
                        "
                      />
                    </v-flex>
                    <v-flex md12 sm12 xs12>
                      <v-autocomplete
                        v-if="form.tipo === 'FILTROS'"
                        v-model="form.titulo"
                        :items="filtros"
                        dense
                        outline
                        clearable
                        small-chips
                        label="Seleccione el filtro"
                        :rules="rules.titulo"
                        :error="!!formErrors.titulo"
                        :error-messages="formErrors.titulo"
                        @keyup="
                          () => {
                            formErrors.titulo = undefined;
                            delete formErrors.titulo;
                          }
                        "
                      />
                    </v-flex>
                  </v-layout>
                  <v-text-field
                    v-model="form.nombre"
                    :disabled="processingForm"
                    label="Nombre"
                    outline
                    :rules="rules.nombre"
                    :error="!!formErrors.nombre"
                    :error-messages="formErrors.nombre"
                    @keyup="
                      () => {
                        formErrors.nombre = undefined;
                        delete formErrors.nombre;
                      }
                    "
                  />
                  
                  <!-- <v-text-field
                    v-if="form.tipo === 'FILTROS'"
                    v-model="form.titulo"
                    :disabled="processingForm"
                    label="Categoría del filtro (Ej: Rango de edad, Tipo de Juego, etc)"
                    outline                    
                    :error="!!formErrors.nombre"
                    :error-messages="formErrors.nombre"
                    @keyup="
                      () => {
                        formErrors.nombre = undefined;
                        delete formErrors.nombre;
                      }
                    "
                  /> -->
                  
                </v-container>
                <v-divider class="mb-3" />
                <div class="text-xs-center pb-3">
                  <v-btn
                    type="submit"
                    color="success"
                    :disabled="!validForm || processingForm"
                    :loading="processingForm"
                    >Guardar</v-btn
                  >
                  <v-btn color="error" @click="$router.push({ name: 'ListaEtiqueta' })"
                    >Cancelar</v-btn
                  >
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: "Nueva Etiqueta" };
  },

  components: {
    NotPermission: () => import("@/views/errors/NotPermission"),
    Breadcrumbs: () => import("@/components/Breadcrumbs")
  },

  data() {
    return {
      formErrors: {},
      form: {
        nombre: "",
        tipo: "",
        titulo: "",
      },
      tipos: ["DESTACADO", "FILTROS", "PROMOCIONES", "SUBCATEGORIA", "DESCUENTOS", "NUEVO"],
      filtros: ["Categoría", "Formato", "Ingredientes", "País", "Productor", "Promociones", "Subcategoría", "Tamaño", "Tipo"],
      validForm: true,
      processingForm: false,

      rules: {
        nombre: [v => !!v || "El nombre es requerido"],
        tipo: [v => !!v || "El tipo es requerido"]
      }
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/check",
      user: "auth/user"
    })
  },
  methods: {
    ...mapActions({
      createEtiqueta: "etiquetas/createEtiqueta"
    }),
    submitCreateEtiqueta() {
      if (!this.$refs.form.validate()) return false;

      this.processingForm = true;
      this.createEtiqueta({ data: this.form })
        .then(response => {
          this.processingForm = false;
          this.$router.push({ name: "ListaEtiqueta" });
        })
        .catch(error => {
          this.processingForm = false;
        });
    }
  }
};
</script>
